// import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
// import React from "react";

// const ProfileScreen = () => {
//   console.log(user, isAuthenticated);
//   return (
//     <div style={{textAlign: "center", position: "absolute", left: "50%", top: "50%", verticalAlign: "middle"}}>
//       {/* <img src={user.picture} alt={user.name} /> */}
//       <h2>{user.name}</h2>
//       <p>{user.email}</p>
//     </div>
//   );
// };

// export default withAuthenticationRequired(ProfileScreen, {
//   onRedirecting: () => <div>Loading. Profile..</div>,
// });

import React from "react";
import { useAuth0, withAuthenticationRequired,LogoutOptions } from "@auth0/auth0-react";
import { useResponsive } from "../../contexts/ResponsiveContext";


const ProfileScreen: React.FC = () => {
  class User {
    name = "John Doe";
    email = "johndoe@example.com";
    picture = "https://tse2.mm.bing.net/th/id/OIP.ZJrWgW4_L78CWjQ-da_vWQHaHa?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3";
  }
  const { user: authUser, isAuthenticated, isLoading,logout } = useAuth0();

  const user = authUser || new User();

  // const { isMobile } = useResponsive();

  // 1. Check for the loading state first
  // if (isLoading) {
  //   return <div>Loading Profile Page...</div>;
  // }

  // 2. Then, check if the user is authenticated
  // if (isLoading) {
  //   return <div>Loading Profile Page...</div>;
  // }

  // if (!isAuthenticated || !user) {
  //   return <div>User not authenticated.</div>;
  // }

  // console.log(user, isAuthenticated);
  return (
    <div style={{ width: '100%', height: '100%', backgroundColor: '#EBF9F5',}}>
      <div style={{paddingTop: '100px', overflow: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'center', textAlign: 'center' }}>
        {/* The user object will only be available here */}
        <img src={user.picture} alt={user.name} style={{ width: '150px', height: '150px', borderRadius: '50%', marginBottom: '20px', objectFit: 'cover' }} />
        <p style={{fontFamily: 'Sarabun, sans-serif',fontSize:'20px'}}>Name : {user.name}</p>
        <p style={{fontFamily: 'Sarabun, sans-serif',fontSize:'20px'}}>Email : {user.email}</p>
        {/* <pre>{JSON.stringify(user, null, 2)}</pre> */}
        <button onClick={() => logout({ returnTo: window.location.origin } as LogoutOptions)} style={{marginTop:'20px',padding: '10px 20px',backgroundColor:'#488DA3',color: '#fff',border: 'none',borderRadius: '5px',cursor: 'pointer',fontSize: '16px',
      }}
    >
      Logout
    </button>
      </div>
    </div>
  );
};

// export default ProfileScreen;

// export default withAuthenticationRequired(ProfileScreen, {
//   onRedirecting: () => <div>Loading. Profile..</div>,
// });

export default ProfileScreen;